import DataFetch from '../../Utility/data-fetch'
import {default as SiteStorage} from '../../Utility/site-cookies';

const call = (baseUrl, passageUrl, readingPlanBaseUrl) => {
    return {
        baseUrl: `${baseUrl}`,
        readingPlanBaseUrl: `${readingPlanBaseUrl}`,
        passageUrl: `${passageUrl}`,

        loading: false,
        itemsPerPage: 10,
        totalPages: 1,
        currentPage: SiteStorage().read('bst_rpd_page', 0),
        currentDetailId: SiteStorage().read('bst_rpd_id', -1),

        readingPlan: null,
        readingPlanDetails: null,
        readingPlanComplete: false,

        async getReadingPlanPage() {
            this.loading = true

            await DataFetch.get(`${this.baseUrl}?page=${this.currentPage}&t=${SiteStorage().readPref('translation', 'niv')}`)
                .then(async (r) => {
                    this.readingPlan = r.data.readingPlan
                    this.readingPlanDetails = r.data.readingPlanDetails
                    this.currentPage = r.data.page
                    this.itemsPerPage = r.data.itemsPerPage
                    this.totalPages = Math.ceil(this.readingPlan.period / this.itemsPerPage)
                    this.readingPlanComplete = r.data.readingPlanComplete
                })
                .catch(() => {
                    this.readingPlan = null
                    this.readingPlanDetails = null
                })

            this.loading = false
        },

        async nextPage() {
            if (this.currentPage < this.totalPages) {
                this.currentPage++
                SiteStorage().write('bst_rpd_page', this.currentPage)
                await this.getReadingPlanPage()
            }
        },

        async previousPage() {
            if (this.currentPage > 1) {
                this.currentPage--
                SiteStorage().write('bst_rpd_page', this.currentPage)
                await this.getReadingPlanPage()
            }
        },

        clearPage() {
            SiteStorage().remove('bst_rpd_page')
        },

        async gotoDetailPassage(translationCode, detailIndex) {
            const targetDetail = this.readingPlanDetails[detailIndex]

            if (!targetDetail) {
                console.log('Detail was not found.')
                return
            }

            SiteStorage().write('bst_rpd_id', targetDetail.readingPlanDetailId)

            window.location.href = `${this.passageUrl}?rdid=${targetDetail.readingPlanDetailId}&t=${translationCode}`
        },

        async markComplete(detailId) {
            await DataFetch.post(`${this.baseUrl}detail-complete/` + detailId)
                .then(async (r) => {
                    this.readingPlanComplete = r.data.readingPlanComplete
                    await this.getReadingPlanPage()
                })
        },

        async markIncomplete(detailId) {
            await DataFetch.remove(`${this.baseUrl}detail-incomplete/` + detailId)
                .then(async () => {
                    this.readingPlanComplete = false
                    await this.getReadingPlanPage()
                })
        },

        async markPlanComplete() {
            await DataFetch.remove(`${this.readingPlanBaseUrl}stop-plan`)
                .then(async () => {
                    window.location.href = `${this.readingPlanBaseUrl}`
                })
        },
    }
}

export default call